import React from 'react';
import cx from 'classnames';
import Link from './Link';
import LinkWithChildren from './LinkWithChildren';

class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(item) {
    this.props.handleClick(item);
  }
  render() {
    const { item, location, locationObj, selectedSubMenuId } = this.props;

    const getStyle = curr =>
      cx({
        'selected active': curr.link === location || (curr.content && curr.content.find(x => x.link === location)),
      });

    let LinkObj;

    if (item.content) {
      //get submenu id based on the route location
      const subId =
        (item.content && item.content.find(x => x.link === location))
          ? item.content.find(x => x.link === location).id
          : 0;

      LinkObj = <LinkWithChildren item={item} handleClick={this.handleClick} selectedSubMenuId={subId} />;
    } else {
      LinkObj = <Link item={item} handleClick={this.handleClick} />;
    }
    return <li className={getStyle(item)}>{LinkObj}</li>;
  }
}

export default Menu;
